import type { PropsWithChildren, ReactNode } from 'react';
import React from 'react';

import { ToastProvider } from '../../wrappers/ToastProvider';

type PaymentViewLayoutProps = {
  header?: ReactNode;
  'data-testid'?: string;
};

export const PaymentViewLayout = ({
  children,
  header,
  'data-testid': dataTestId,
}: PropsWithChildren<PaymentViewLayoutProps>) => (
  <ToastProvider>
    <div className="h-full max-h-[100dvh] overscroll-none relative w-full flex flex-row text-md overflow-x-hidden">
      <div
        className="flex flex-col h-full w-full overflow-x-hidden overflow-y-hidden"
        data-testid={dataTestId}
      >
        {header && (
          <div
            data-testid="payment-view-header"
            className="flex flex-row justify-between w-full gap-y-f2 flex-wrap h-fit border-b-[0.5px] border-main-300"
          >
            {header}
          </div>
        )}
        <div
          data-testid="payment-view-main"
          className="flex flex-col w-full h-full overflow-y-scroll scrollbar-hide pt-f2"
        >
          <div
            data-testid="payment-view-content"
            className="h-full w-full flex-col max-h-full pl-f1 laptop:pl-f2"
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  </ToastProvider>
);

type HeaderProps = {
  disabled?: boolean;
};

export const PaymentViewHeader = ({
  children,
  disabled,
}: PropsWithChildren<HeaderProps>) => (
  <div className="flex flex-col items-start pt-f2 pl-f2 h-f8 w-full">
    {children}
  </div>
);

export const PaymentViewLoading = ({
  message = 'Loading...',
}: {
  message?: string;
}) => (
  <PaymentViewLayout>
    <div className="text-main-500">{message}</div>
  </PaymentViewLayout>
);
